import { render, staticRenderFns } from "./review-close-popup.vue?vue&type=template&id=4c02c9f9"
import script from "./review-close-popup.vue?vue&type=script&lang=ts"
export * from "./review-close-popup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports